import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-group-card',
  templateUrl: './split-group-card.component.html',
  styleUrls: ['./split-group-card.component.scss']
})
export class SplitGroupCardComponent {
  @Input() public label = '';
}
